// Um modal só pra todo o painel: fundo escuro, Esc fecha, clique fora fecha.
// `Confirmacao` é o "tem certeza?" com o texto do que vai acontecer — o
// appShowConfirm do legado.
import { useEffect, type ReactNode } from 'react';
import estilos from './Modal.module.css';

export function Modal({ titulo, aoFechar, largura = 460, children }: { titulo: string; aoFechar: () => void; largura?: number; children: ReactNode }) {
  useEffect(() => {
    const aoTeclar = (e: KeyboardEvent) => { if (e.key === 'Escape') aoFechar(); };
    document.addEventListener('keydown', aoTeclar);
    return () => document.removeEventListener('keydown', aoTeclar);
  }, [aoFechar]);
  return (
    <div className={estilos.fundo} onClick={(e) => { if (e.target === e.currentTarget) aoFechar(); }}>
      <div className={estilos.caixa} role="dialog" aria-modal="true" aria-label={titulo} style={{ width: largura }}>
        <div className={estilos.topo}>
          <h2 className={estilos.titulo}>{titulo}</h2>
          <button type="button" className={estilos.fechar} onClick={aoFechar} aria-label="Fechar">✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

export interface PedidoDeConfirmacao {
  titulo: string;
  mensagem: ReactNode;
  confirmar?: string;
  perigo?: boolean;
}

export function Confirmacao({ pedido, aoResponder }: { pedido: PedidoDeConfirmacao | null; aoResponder: (sim: boolean) => void }) {
  if (!pedido) return null;
  return (
    <Modal titulo={pedido.titulo} aoFechar={() => aoResponder(false)}>
      <div className={estilos.mensagem}>{pedido.mensagem}</div>
      <div className={estilos.acoes}>
        <button type="button" className="botao discreto" onClick={() => aoResponder(false)}>Cancelar</button>
        <button type="button" className={`botao ${pedido.perigo ? 'perigo' : 'primario'}`} onClick={() => aoResponder(true)}>{pedido.confirmar ?? 'Confirmar'}</button>
      </div>
    </Modal>
  );
}
